import React, { useEffect, useState } from "react";
import API from "../../../utils/Api";
import dateFormat from "dateformat";
import * as S from "./ReportStyled";
import ResponsiveRow from "./ResponsiveRow";
// import SelectDate from "../filter/SelectDate";
import Dropdown from "../filter/Dropdown";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import Loader from "../../common/loader";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


function RetailerWiseComparisonReport() {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [loading, setLoading] = useState(true);
  const [data, setdata] = useState(null);
  const [productData, setProductData] = useState(null);
  const [salesPersonData, setSalesPersonData] = useState(null);
  const [prodIndex, setProdIndex] = useState(0);
  const [salesIndex, setSalesIndex] = useState(0);

  const [recType, setRecType] = useState(['All', 'More', 'Less', 'Zero' ]);


  const getData = async (init) => {
    setLoading(true);


    // console.log(dateFormat(startDate, "mm"), dateFormat(startDate, "yyyy"))
    const pID = productData === null? 0 : productData[prodIndex].id;

    // console.log(`Rec type : ${recType[salesIndex]}`)
    // console.log(`First Month : ${dateFormat(startDate, "mm")}`)
    // console.log(`Second Month : ${dateFormat(startDate, "yyyy")}`)
    // console.log(`First Year : ${dateFormat(endDate, "mm")}`)
    // console.log(`Second Year : ${dateFormat(endDate, "yyyy")}`)


    let response = await API.get(
      "/report/RetailerwiseComparisonReport",
      {
        params: {

          firstMonth : dateFormat(startDate, "mm"),
          firstYear : dateFormat(startDate, "yyyy"),
          secondMonth :dateFormat(endDate, "mm"),
          secondYear : dateFormat(endDate, "yyyy"),
          reportType : recType[salesIndex],
          productId : pID

        },
        headers: { Token: localStorage.getItem("token") },
      }
    );

    // console.log(response.data.data.results)



    if (init) {
      let salesResponse = await API.get(`salesperson/SalesPersonAll`, {
        headers: { Token: localStorage.getItem("token") },
      });
      let prodResponse = await API.get(`product/productall`, {
        headers: { Token: localStorage.getItem("token") },
      });
      setSalesPersonData([
        { salespersonName: "All" },
        ...salesResponse.data.data.results,
      ]);
      setProductData([
        { id: 'All', productName: "All" },
        ...prodResponse.data.data.results,
      ]);
    }
    setdata(response.data.data.results);
    setLoading(false);
  };

  useEffect(() => {
    getData(true);
  }, []);

  useEffect(() => {
    getData();
  }, [startDate, endDate, prodIndex, salesIndex]);

  return (
    <S.Wrapper>
      <ResponsiveRow
        items={[
          <DatePicker
          selected={startDate}
          onChange={(date) => setStartDate(date)}
          selectsStart
          startDate={startDate}
          endDate={endDate}
          dateFormat="MM/yyyy"
          showMonthYearPicker
        />,
        <DatePicker
        selected={endDate}
        onChange={(date) => setEndDate(date)}
        selectsEnd
        startDate={startDate}
        endDate={endDate}
        dateFormat="MM/yyyy"
        showMonthYearPicker
      />,
          productData && (
            <Dropdown
              label="Choose Product:"
              onSelect={(index) => {
                setProdIndex(index);
              }}
              selectedItem={prodIndex}
              options={productData.map((e, index) => ({
                value: index,
                title: e.productName,
              }))}
            />
          ),

          salesPersonData && (
            <Dropdown
              label="Choose Record Type"
              onSelect={(index) => { setSalesIndex(index) }}
              selectedItem={salesIndex}
              options={[
                {
                  value: 0,
                  title: 'All',
                },
                {
                  value: 1,
                  title: 'More',
                },
                {
                  value: 2,
                  title: 'Less',
                },
                {
                  value: 3,
                  title: 'Zero',
                },
              ]}
            />
          ),
          <S.Text>Retailer Wise Comparison</S.Text>,
          <ReactHTMLTableToExcel
            id="download-button"
            className="download"
            table="reports"
            filename="reports"
            sheet="report"
            buttonText={
              <span>
                <img
                  width={25}
                  height={25}
                  src="https://img.icons8.com/ios/50/000000/ms-excel.png"
                  alt={"Excel"}
                />{" "}
                Excel
              </span>
            }
          />,
        ]}
        table={
          loading ? (
            <Loader />
          ) : (
            <S.TableWrapper>
              <S.Table id="reports">
                <S.TableRow>
                  <S.TableHeader style={{ textAlign: "center" }}>
                    Retailer Name
                  </S.TableHeader>
                  <S.TableHeader style={{ textAlign: "center" }}>
                    Mobile Number
                  </S.TableHeader>
                  <S.TableHeader style={{ textAlign: "center" }}>
                    Current Amount
                  </S.TableHeader>
                  <S.TableHeader style={{ textAlign: "center" }}>
                    Previous Amount
                  </S.TableHeader>
                </S.TableRow>


                <S.TableBody>
                  {
                  data.map((e) =>
                    e.sales.map((sale, index) => {
                      // console.log(sale)
                      if(recType[salesIndex] === "More" && sale.currentAmount < sale.previousAmount)
                      {
                        return null;
                      }
                      else if(recType[salesIndex] === "Less" && sale.currentAmount > sale.previousAmount)
                      {
                        return null;
                      }
                      else if(recType[salesIndex] === "Zero" && sale.currentAmount > 0 && sale.previousAmount > 0)
                      {
                        return null;
                      }
                      else return(
                        <S.TableRow key={index}>
                          <S.TableData>{e.retailerName}</S.TableData>
                          <S.TableData width={150}>
                            <span>
                              <img
                                alt={index}
                                src={sale.image}
                                height="20"
                                width="20"
                                style={{ marginRight: "6px" }}
                              />
                              {sale.productName}
                            </span>
                          </S.TableData>
                          <S.TableData style={{ textAlign: "right" }}>
                            ₹ {sale.currentAmount.toLocaleString("en-IN")}
                          </S.TableData>
                          <S.TableData style={{ textAlign: "right" }}>
                            ₹ {sale.previousAmount.toLocaleString("en-IN")}
                          </S.TableData>
                        </S.TableRow>
                      );
                    })
                  )}
                </S.TableBody>


              </S.Table>
            </S.TableWrapper>
          )
        }
      />
    </S.Wrapper>
  );
}

export default RetailerWiseComparisonReport;
